import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dbdcbcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-tools" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("搜索名称")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索说明")
const _hoisted_12 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_13 = { class: "card-body table-responsive p-0" }
const _hoisted_14 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_15 = { ref: "tableTr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "holidayStatus" }, "状态", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "holidayRulesId" }, "月份", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "holidayRulesName",
  class: "normal-width text-left"
}, "规则", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_23 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "table-btn-group" }
const _hoisted_31 = { class: "btn-group" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_35 = { class: "content-modal" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1rem","font-weight":"bold"} }, "请选择规则", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正常", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不过期", -1))

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_app_switch_number = _resolveComponent("app-switch-number")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/attendance/duty/dutyHolidayRules/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/attendance/duty/dutyHolidayRules/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[0] || (_cache[0] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_7
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _hoisted_9,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchFunction('org_type_name')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_10
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchFunction('org_type_remark')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_11
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[6] || (_cache[6] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.Auth('/attendance/duty/dutyHolidayRules/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_15, _hoisted_23, 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_26
                          ], 8, _hoisted_25)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.batchId,
                        class: _normalizeClass({'text-red': parseInt(item.holidayStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        (parseInt(item.holidayStatus)===1)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.toggleStatus(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                name: "checkmark-circle-outline",
                                class: "hyper-text-themes"
                              })
                            ], 8, _hoisted_27))
                          : (parseInt(item.holidayStatus)===2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                                _createVNode(_component_svg_icon, {
                                  name: "close-circle-outline",
                                  class: "text-red"
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_29, "未知")),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            (_ctx.Auth('/attendance/duty/dutyHolidayRules/mod'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.modModalOpen(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "settings-outline" })
                                ], 8, _hoisted_32))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.holidayRulesId), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(item.holidayRulesName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_35, [
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _hoisted_36,
          _createVNode(_component_el_form_item, { style: {"padding-top":"1rem"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.editModalItem.holidayRules,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.editModalItem.holidayRules) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: 1,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 2,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_app_switch_number, {
            label: "状态",
            modelValue: _ctx.editModalItem.holidayStatus,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.editModalItem.holidayStatus) = $event)),
            enableName: "启用",
            disabledName: "禁用"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}